let selectors = document.querySelectorAll('select:not(.js-select2)');
selectors.forEach((item, id) => {
    let options = item.children,
        select = document.createElement('div'),
        selectStyled = document.createElement('div'),
        optionList = document.createElement('ul'),
        selectedOption = "";
    select.className = 'select';
    selectStyled.className = 'select-styled';
    if (item.disabled) {
        selectStyled.classList.add('disabled');
    }
    item.classList.add('select-hidden');
    select.innerHTML = item.outerHTML;
    item.parentNode.replaceChild(select, item);
    select.appendChild(selectStyled);
    optionList.className = 'select-options';
    select.appendChild(optionList);
    for (let option of options) {
        if (option.getAttribute('data-value') !== 'hide') {
            let optionsListItem = document.createElement('li');
            optionsListItem.innerText = option.innerText;
            optionsListItem.setAttribute('rel', option.value);
            optionList.appendChild(optionsListItem);
        }
        if (option.getAttribute('selected')) {
            selectedOption = option.innerText;
        }
    }
    if (options.length > 0) {
        selectStyled.innerText = selectedOption.length > 0 ? selectedOption : options[0].innerText;
    }
});
// Тут я уже забиваю в переменые рание созданые элементы. Что бы повесить на них слушатели.
let selectStyled = document.querySelectorAll('.select-styled'),
    optionList = document.querySelectorAll('.select-options'),
    optionListItem = document.querySelectorAll('.select-options li');


//data

let openedSelector = null;
// functions
const activeSelector = (element) => {
    openedSelector = element;
    element.classList.add('active');
    element.getBoundingClientRect().bottom > 450 ? element.nextSibling.classList.add('select-options-show', 'drop_up') : element.nextSibling.classList.add('select-options-show');
};
export const unActiveSelector = () => {
    openedSelector = null;
    selectStyled.forEach((item) => {
        item.classList.remove('active');
        item.nextSibling.classList.remove('select-options-show','drop_up');
    });
}
// listeners
selectStyled.forEach((item) => {
    item.addEventListener('click', (e) => {
        e.stopPropagation();
        if (!(e.target.className.includes('disabled'))) {
            if (e.target !== openedSelector) {
                unActiveSelector();
                activeSelector(e.target);
            }
            else {
                unActiveSelector();
            }
        }

    });
});
document.body.addEventListener('click', e => {
    let optionItems = document.querySelectorAll('.select-options li');
    optionItems.forEach(item => {
        if (e.target === item) {
            unActiveSelector();
            let newValue = item.innerText,
                optionValue = item.getAttribute('rel'),
                select = item.parentNode.previousElementSibling.previousElementSibling;
            item.parentNode.previousElementSibling.innerText = newValue;
            select.value = optionValue;
            let event = new Event("change", {"bubbles":true, "cancelable":false});
            select.dispatchEvent(event);
        }
    })
})
document.addEventListener('click', (e) => {
    unActiveSelector();
});
